import React from 'react';
import { MapPinIcon } from '@heroicons/react/20/solid';
import { Rating } from "react-simple-star-rating";
import { numberFormat } from '../../Utils';
import { ReactSVG } from 'react-svg';
import { capitalize } from '../../Utils';

const VenueListItem = (props) => {
  const venue = props.data;

  // const facilities = data.facilities.split(', ');

  const handleClick = (e) => {
    e.preventDefault();
    if (props.onClick) {
      props.onClick(venue);
    }
  };

  return (
    <div onClick={handleClick} className='cursor-pointer'>
      <div className='flex flex-1 border border-borderGray rounded-xl transition-shadow overflow-hidden flex-col hover:shadow-lg transition-all'>
        <div className='relative w-full aspect-[280/171] bg-borderGray'>
          <img
            className='aspect-[280/171] object-cover'
            src={venue.cover.replace('1993', '1919')}
            alt='Venue cover'
            onError={(e) => (e.target.src = '/ic_lapang_empty.svg')}
          />

          {/* Discount badge */}
          {/* <div className='absolute bottom-0 right-0 bg-[#ffffff] bg-opacity-90 text-[#343434] px-3 py-1 rounded-tl-xl text-sm'>
            Disc. <span className='font-bold'>+10% </span><img src='logo_blu.png' className='inline-block h-4 ml-1' />
          </div> */}
        </div>


        <div className='flex flex-col justify-between'>
          <div className='flex flex-col pt-3 px-4 pb-4'>

            {/* Sport Type + Rating Section */}
            <div className="flex flex-1 justify-between items-center">
              <p className="flex items-center text-[12px] font-semibold">
                <ReactSVG
                  src={`/sport-type/light/ic-${venue.sport_type.replaceAll(" ", "-").toLowerCase()}.svg`}
                  afterInjection={(svg) => {
                    svg.setAttribute("fill", "#000");
                    svg.setAttribute("height", "18");
                    svg.setAttribute("width", "18");
                  }}
                  className="mr-2"
                />
                {capitalize(venue.sport_type)}
              </p>

              {/* Rating Section */}
              {venue.rating > 0 && (
                <div className="flex items-center text-[14px] font-bold">
                  <Rating
                    className="-mt-1 mr-0.5"
                    iconsCount={1}
                    fillColor="#ffaa00"
                    size={22}
                    initialValue={1}
                    readonly
                  />
                  <span>{venue.rating}</span>
                </div>
              )}
            </div>

            {/* Venue Name */}
            <p className='text-[14px] font-extrabold mt-2'>{venue.name}</p>

            {/* Location Section */}
            <div className='flex items-start mt-2'>
              <MapPinIcon className='w-4 grow-0 shrink-0 text-textGray mt-1' />
              <p className='ml-3 text-xs text-textGray'>{venue.location} </p>
            </div>
            {/* <div className='flex items-start mt-2'> */}
            {/* <ReactSVG
                src={`/ic_lapang.svg`}
                afterInjection={(svg) => {
                  svg.setAttribute("fill", "#898989");
                  svg.setAttribute("height", "18");
                  svg.setAttribute("width", "18");
                }}
                className="w-4 grow-0 shrink-0 text-textGray"
              /> */}
            {/* <p className='ml-3 text-xs text-textGray'>{venue.available_session} Sesi Tersedia</p> */}
            {/* </div> */}

            {/* Price Section */}
            <p className='text-xs mt-4'>Mulai dari</p>
            <p className='flex w-full'>
              <span className='text-gray-800 text-sm font-bold'>Rp{numberFormat(venue.start_from, false)}</span>
              <span className='ml-1 text-sm text-gray-800 font-base'> / Sesi</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VenueListItem;
